import { FunctionComponent, SVGProps } from "react"
import styled from "styled-components"

const Container = styled.div`
  display: flex;
  gap: 8px;
  background: #f8fafc;
  min-height: 32px;
  margin-bottom: 20px;
  padding: 0 10px 0 20px;
  align-items: center;
  justify-content: space-between;
`

const Title = styled.h4`
  font-size: 0.75rem;
  text-transform: uppercase;
  color: #64748b;
`

const TitleContent = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  padding: 8px 0;
`

interface ModalSectionTitleProps {
  Icon?: FunctionComponent<SVGProps<SVGSVGElement>>
  title: string
  children?: React.ReactNode
}

const ModalSectionTitle = ({ Icon, title, children }: ModalSectionTitleProps) => {
  return (
    <Container>
      <TitleContent>
        {Icon && <Icon />}
        <Title>{title}</Title>
      </TitleContent>
      {children && <ActionsWrapper>{children}</ActionsWrapper>}
    </Container>
  )
}

export default ModalSectionTitle
